import { RadialBar, RadialBarChart, Tooltip } from "recharts";
import { UseApiCallInternalDashboard } from "pages/internal-dashboard/hooks/use-api-call";
import { ConditionalRenderer } from "components";
import { Spin } from "antd";
import { useMemo } from "react";
import { getCountDataFinal } from "../../helpers";
import styles from "./styles.module.scss";

const chartSize = window.innerWidth > 1700 ? 253 : 210;

export const Chart = () => {
  const { data: deviceTypeCount, isLoading: deviceTypeCountLoading } =
    UseApiCallInternalDashboard({
      url: "deviceType/count",
      method: "GET",
    });

  const countFinalData = useMemo(
    () => getCountDataFinal(deviceTypeCount?.data),
    [deviceTypeCount],
  );

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { deviceType, percentage } = payload[0].payload;
      return (
        <div className="custom-tooltip" style={{ width: "fit-content" }}>
          <p>{`${
            deviceType.charAt(0).toUpperCase() + deviceType.slice(1)
          }: ${percentage}%`}</p>
        </div>
      );
    }

    return null;
  };

  return (
    <div className={styles.chartWrapper}>
      <Spin spinning={deviceTypeCountLoading}>
        <div className={styles.radialChartCard}>
          <ConditionalRenderer condition={countFinalData}>
            <RadialBarChart
              width={chartSize}
              height={chartSize}
              innerRadius="40%"
              outerRadius="80%"
              data={countFinalData}
              barSize={7}
              startAngle={0}
              endAngle={360}
            >
              <RadialBar
                minAngle={15}
                background
                clockWise
                dataKey="percentage"
              />

              <Tooltip content={<CustomTooltip />} />
            </RadialBarChart>
          </ConditionalRenderer>
          <div className={styles.labelsContainer}>
            {countFinalData?.map((item) => (
              <ConditionalRenderer condition={item.deviceType}>
                <SingleLabel data={item} key={item.deviceType} />
              </ConditionalRenderer>
            ))}
          </div>
        </div>
      </Spin>
    </div>
  );
};

function SingleLabel({ data }) {
  const { fill, deviceType, percentage } = data;

  return (
    <div className={styles.singleLabel}>
      <span style={{ backgroundColor: fill }}></span>
      <p style={{ textTransform: "capitalize" }}>{deviceType}</p>
      <div>{percentage}%</div>
    </div>
  );
}
